/**
 * Limpa todos os caches module-level dos hooks de dados (Task #196).
 *
 * O projeto não usa React Query/SWR — cada hook mantém um cache module-level
 * próprio com uma função `invalidate*Cache()`. O botão "Atualizar" da TopBar
 * chama isto + força um remount da view atual (key em App) pra os hooks
 * re-dispararem o fetch contra a rede (cache limpo = sem hit).
 *
 * Incluir um cache a mais aqui é inócuo (clear de Map/null). Ao criar um hook
 * novo com cache, adicione o invalidate dele aqui pra entrar no "Atualizar".
 */
import { invalidateCalendario6dusCache } from "../hooks/useCalendario6dus";
import { invalidateContasReceberCache } from "../hooks/useContasReceber";
import { invalidateCurvaForwardCache } from "../hooks/useCurvaForward";
import { invalidateCurvaPreCache } from "../hooks/useCurvaPre";
import { invalidateDespesasV2Cache } from "../hooks/useDespesasV2";
import { invalidateIpcaCache } from "../hooks/useIpca";
import { invalidateDreV2Cache } from "../hooks/useDreV2";
import { invalidateFluxoV2Cache } from "../hooks/useFluxoV2";
import { invalidateLastSyncCache } from "../hooks/useLastSync";
import { invalidatePldHistoricoCache } from "../hooks/usePldHistorico";
import { invalidatePldOverviewCache } from "../hooks/usePldOverview";
import { invalidatePldSemanasCache } from "../hooks/usePldSemanas";
import { invalidatePosicaoAbertaCache } from "../hooks/usePosicaoAberta";
import { invalidatePosicaoAbertaMtm6mCache } from "../hooks/usePosicaoAbertaMtm6m";
import { invalidateProximo6duCache } from "../hooks/useProximo6du";
import { invalidateRhCache } from "../hooks/useRh";
import { invalidateSaldoV2Cache } from "../hooks/useSaldoV2";
import { invalidateVarejoCache } from "../hooks/useVarejo";
import { invalidateZeusStatusCache } from "../hooks/useZeusStatus";

export function refreshAllCaches(): void {
  invalidateCalendario6dusCache();
  invalidateContasReceberCache();
  invalidateCurvaForwardCache();
  invalidateCurvaPreCache();
  invalidateDespesasV2Cache();
  invalidateIpcaCache();
  invalidateDreV2Cache();
  invalidateFluxoV2Cache();
  invalidateLastSyncCache();
  invalidatePldHistoricoCache();
  invalidatePldOverviewCache();
  invalidatePldSemanasCache();
  invalidatePosicaoAbertaCache();
  invalidatePosicaoAbertaMtm6mCache();
  invalidateProximo6duCache();
  invalidateRhCache();
  invalidateSaldoV2Cache();
  invalidateVarejoCache();
  invalidateZeusStatusCache();
}
